<h3>Pourquoi ?</h3>


<input class="col-12" placeholder="Commentaire" [(ngModel)]="why">

<button class="btn-secondarycrm" (click)="saveChange()" [style.opacity]="why === '' ? '0.4' : '1'" [disabled]="why === ''">Confirmer</button>
